import { observer } from 'mobx-react-lite'
import { useSyncStepWithHash } from '@/features/jobs/drafting/draft-job-hooks'
import { type DraftJobViewModel } from '@/features/jobs/drafting/DraftJobViewModel'
import { SubmissionViewModel } from '@/features/jobs/drafting/SubmissionViewModel'
import { JobCreationFormView } from '@/features/jobs/drafting/components/JobCreation/JobCreationFormView'
import { FormSubmissionContainer } from '@/features/jobs/drafting/components/JobCreation/JobCreationFormView/FormSubmission/FormSubmissionContainer'
import { StepContainer } from '@/features/jobs/drafting/components/JobCreation/JobCreationFormView/Step/StepContainer'
import { renderStepContent } from './render-step-content'

export interface JobCreationFormViewContainerProps {
  vm: DraftJobViewModel
}

export const JobCreationFormViewContainer = observer(
  function JobCreationFormViewContainer({
    vm,
  }: JobCreationFormViewContainerProps) {
    useSyncStepWithHash(vm.outline)

    return (
      <JobCreationFormView isLoading={vm.isFormLoading}>
        {vm.outline.stepAccessors.map((stepAccessor) => (
          <StepContainer
            key={stepAccessor.step.stepId}
            stepAccessor={stepAccessor}
            isNumbered
          >
            {stepAccessor instanceof SubmissionViewModel ? (
              <FormSubmissionContainer vm={stepAccessor} />
            ) : (
              renderStepContent(stepAccessor)
            )}
          </StepContainer>
        ))}
      </JobCreationFormView>
    )
  },
)
